import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./hooks/AuthContext";

import GlobalStyles from "./styles/GlobalStyles";
import Router from "./routes";
import CustomToast from "./components/CustomToast";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Router />
      </AuthProvider>
      <GlobalStyles />
      <CustomToast />
    </BrowserRouter>
  );
}

export default App;
